import { render, staticRenderFns } from "./ActiveWalletUsers.vue?vue&type=template&id=5ce2eef5&scoped=true&"
import script from "./ActiveWalletUsers.vue?vue&type=script&lang=js&"
export * from "./ActiveWalletUsers.vue?vue&type=script&lang=js&"
import style0 from "./ActiveWalletUsers.vue?vue&type=style&index=0&id=5ce2eef5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce2eef5",
  null
  
)

export default component.exports